import { createAction, props } from '@ngrx/store';
import { MapViewport, SearchHistoryEntry, SearchDomain } from './search-history.model';

export const restoreExecutedSearch = createAction('[Search History] Restore', props<SearchHistoryEntry & { recordHistory?: boolean }>());
export const resetSearchHistorySession = createAction('[Search History] Reset Session');
export const searchViewportChanged = createAction('[Search History] Viewport', props<{ domain: SearchDomain; viewport: MapViewport }>());
